function initDateRange(index, node) {
    $(node).datepicker(makeDateRangeParams(node).datepickerParams);
    let $this = $(node);
    $('input[type=text]', $(node)).on('change', function () {
        if ($(this).val() != '') {
            $this.addClass('_x');
        } else {
            $this.removeClass('_x');
        }
    });
}


function initDateRangeYear(index, node) {
    $(node).datepicker(makeDateRangeParams().datepickerYearParams);
    let $this = $(node);
    $('input[type=text]', $(node)).on('change', function () {
        if ($(this).val() != '') {
            $this.addClass('_x');
        } else {
            $this.removeClass('_x');
        }
    });
}

function initDateRangeRange(index, node) {
    $(node).datepicker(makeDateRangeParams().datepickerParams);
    // let $this = $(node);
    // $('input[type=text]', $(node)).on('change', function () {
    //     if ($(this).val() != '') {
    //         $this.addClass('_x');
    //     } else {
    //         $this.removeClass('_x');
    //     }
    // });
}

function makeDateRangeParams(node) {
    let datepickerYearParams = {
        language: 'ru',
        format: 'yyyy',
        viewMode: "years",
        minViewMode: "years",
        orientation: "bottom auto",
        autoclose: true,
        endDate: new Date().getFullYear().toString(),
    };

    let datepickerParams = {
        language: 'ru',
        format: 'dd.mm.yyyy',
        orientation: "bottom auto",
        endDate: '0d'
    };

    if ($('html').hasClass('_lang-en')) {
        datepickerParams.language = 'en';
        datepickerYearParams.language = 'en';
        datepickerParams.format = 'mm/dd/yyyy';
    } else if ($('html').hasClass('_lang-ch')) {
        datepickerParams.language = 'zh-CN';
        datepickerYearParams.language = 'zh-CN';
        datepickerParams.format = 'mm/dd/yyyy';
    }


    if ($(node).data('end-date-without')) {
        delete datepickerParams.endDate;
    }

    return {
        datepickerParams,
        datepickerYearParams,
    }
}

$(function () {

    App.Datepicker = {

        init: function () {

            $('.js--daterange').each(initDateRange);
            $('.js--daterange-year').each(initDateRangeYear);

            $(document).on('click', '.daterange-item__x', function (e) {
                e.preventDefault();
                $('.js--daterange').datepicker('clearDates');
            });

        }

    };
    App.Datepicker.init();

});